var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.238474 25.7792L6.78644 14.7821C6.83137 14.6898 6.78662 14.5859 6.68553 14.5859H0.474298C0.0474889 14.5859 -0.121087 14.2859 0.0923175 13.9282L8.15669 0.484639C8.32517 0.196151 8.6284 0 8.96535 0H15.1878C15.6146 0 15.7382 0.311574 15.5136 0.657759L9.30236 9.52007C9.23497 9.61239 9.30245 9.71622 9.3923 9.71622H16.4909C16.9626 9.71622 17.1758 10.3278 16.8276 10.6509L0.451813 25.9523C0.317031 26.0792 0.148619 25.9292 0.238474 25.7792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.c7fdede25ea8c4a5cac50052e6c39009.svg";
export { ForwardRef as ReactComponent };